import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import CreateDocTypeV2Modal from "./CreateDocTypeV2Modal";
import Constants from "../../../../common/SupplierConstants";
import CustomerConstants from "../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import {
  addRfxNr,
  addRfqCreation,
  addcustomerID,
  getRfqleList,
} from "../../../../redux/feature/customer_app/customerSlice";

import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import ReverseTimer from "../../../../Components/TableReverseTimer/ReverseTimer";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";
import TableActions from "../../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";

const RequestForQuotationListV2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Project");
  localStorage.setItem("submenu", "Request for Quotation");

  let rfqData = useSelector((state) => state?.customer?.rfq); // User Details from Store
  let customerTable = useSelector((state) => state?.customer?.rfq?.pagination); // User Details from Store

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [filterShow, setFilterShow] = useState(false);
  const [getFilter, setFilter] = useState({});

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [
    // {
    //   name: "Collaboration",
    //   cell: (row) => (
    //     <>
    //       <span>
    //         <i className="bi bi-git iconTable"></i>
    //       </span>
    //       <span>
    //         <i className="bi bi-collection-play iconTable"></i>
    //       </span>
    //       <span>
    //         <i className="bi bi-stack iconTable"></i>
    //       </span>
    //     </>
    //   ),
    //   width: "150px",
    // },
    {
      name: "Buyer RFQ Details",
      id: "rfxNr",
      selector: (row) => row.rfxNr,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageBuyer(row.rfxNr)}
        >
          {row.rfxNr}{" "}
        </button>
      ),
      width: "160px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            // onClick={() => lineItemLevelShowModal(row.items)}
            onClick={() =>
              lineItemLevelShowModal(
                Array.isArray(row.items) ? row.items : [row.items],
              )
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          {/* <span className="suppliersIcon"> {row.items?.length} </span> */}
          <span className="suppliersIcon">
            {" "}
            {Array.isArray(row.items) ? row.items.length : 1}{" "}
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Title",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold"> {row.rfxTitle} </span>
        </>
      ),
      selector: (row) => row.rfxTitle,
      sortable: true,
      width: "150px",
    },
    {
      name: "RFQ Type",
      id: "rfqType",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold"> {row.rfqType} </span>
        </>
      ),
      selector: (row) => row.rfqType,
      sortable: true,
      width: "150px",
    },
    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row?.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowActionLogs)}
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    {
      name: "Status",
      id: "rfxHeaderStatus",
      selector: (row) => row.rfxHeaderStatus,
      cell: (row) => (
        <>
          <TableStatusField status={row.rfxHeaderStatus} />
        </>
      ),
      width: "180px",
    },
    {
      name: " RFQ Value",

      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.rfxValue).toFixed(2))}
        </span>
      ),
      selector: (row) => row.rfxValue,
      sortable: true,
      width: "120px",
    },
    {
      name: "Open Date ",
      id: "openingDateTime",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Close Date",
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Countdown Timer",
      cell: (row) =>
        row.rfxHeaderStatus === "PO Created" ? (
          <ReverseTimer timerData={0} />
        ) : (
          <ReverseTimer
            closingDateTime={row.closingDateTime}
            openingDateTime={row.openingDateTime}
          />
        ),
      sortable: true,
      width: "270px",
    },
    {
      name: "Quotations",
      cell: (row) => (
        <>
          <button
            className="btnTable"
            onClick={() => detailedCommercialEvaluation(row.rfxNr)}
          >
            Comparison
          </button>
        </>
      ),
      width: "140px",
    },
    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyCodeDesc} </span>
        </>
      ),
      width: "200px",
    },
    {
      name: "Buyer Responsible",
      cell: (row) => (
        <div className="d-flex flex-column">
          <p className="m-0 fw-bold"> {row.createdByName} </p>
          <p className="m-0"> {row.initiator} </p>
        </div>
      ),
      width: "200px",
    },
    {
      name: "Buyer Contact",
      selector: (row) => row.buyerEmail,
      sortable: true,
      width: "250px",
    },
    {
      name: "Product",
      selector: (row) => row.productType,
      sortable: true,
      width: "150px",
    },
    {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              // onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];
  const LineItemsColInfo = [
    {
      name: "RFQ Item Number",
      selector: (row) => row.indentDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "PR Number",
      selector: (row) => row.purchasingDocumentNr,
      width: "200px",
    },
    {
      name: "Material Code",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "250px",
    },
    {
      name: "Material Desc",
      selector: (row) => row.materialDescription,
      sortable: true,
      width: "250px",
    },
    {
      name: "Quantity Unit",
      selector: (row) => row.orderUnitOfMeasure || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Quantity",
      selector: (row) => row.indentQuantity,
      sortable: true,
      width: "250px",
    },
    {
      name: "Item Rate",
      selector: (row) => row.netValue,
      sortable: true,
      width: "250px",
    },
  ];

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on Line Item Level Data
  const lineItemLevelShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(LineItemsColInfo);
    setModalTitle("Line Item Level Details");
    setItemLevelModalShow(true);
  };
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const createRFQ = () => {
    dispatch(addRfqCreation("Manual"));
    navigate(CustomerConstants.CUSTOMER_V2_RFQ_CREATION_MANUAL);
  };

  const hideModal = () => {
    setModalShow(false);
  };
  const detailedPageBuyer = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(CustomerConstants.CUSTOMER_V2_RFQ_DETAIL);
  };
  const loadInitialData = () => {
    setData(rfqData?.data);
  };

  //Create CE
  const detailedCommercialEvaluation = (rfxNr) => {
    dispatch(addRfxNr(rfxNr));
    navigate(CustomerConstants.CUSTOMER_V2_RFQ_COMMERCIAL_EVALUATION);
  };

  useEffect(() => {
    loadInitialData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfqData]);

  const getMasterData = async () => {
    let obj = {
      codeType: "RFQCategory",
    };
    await ItemService.getMasterData(obj).then((item) => {
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  //on page load
  useEffect(() => {
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "GET_RFX_LIST",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getRfqleList(obj));
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "GET_RFX_LIST",
      module: "",
      page: page,
      per_page: newPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };
    setNewPerPage(newPerPage);
    dispatch(getRfqleList(obj));
    setData(rfqData?.data);
  };
  const handlePageChange = (page) => {
    let obj = {
      queryName: "GET_RFX_LIST",
      module: "",
      page: page,
      per_page: getNewPerPage,

      rowFilter: {
        $and: [getFilter],
      },
    };

    dispatch(getRfqleList(obj));
    setData(rfqData?.data);
  };

  //on page load
  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      queryName: "GET_RFX_LIST",
      module: "",
      page: 1,
      per_page: 10,
      timeZone: "Asia/Calcutta",
    };
    dispatch(getRfqleList(obj));
    // getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "GET_RFX_LIST",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getRfqleList(obj));
    // dispatch(getCustomerList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Request For Quotation</h2>
                <p className="subText">
                  Lists of Request For Quotation and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={columns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RQ</span>
                    </Col>
                    <Col xs={4} md={6} lg={8}>
                      <span className="headerTitle">RFQ List</span>
                      <span className="subHeaderTitle">
                        View of Request For Quotation and Status{" "}
                      </span>
                    </Col>
                    <Col xs={4} md={8} lg={2} className="me-2">
                      <button className="btnTable" onClick={() => createRFQ()}>
                        <i className="bi bi-plus-lg"></i> Create RFQ
                      </button>
                    </Col>
                    {/*    <Col xs={4} md={8} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-x-circle"></i> Cancel
                      </button>
                    </Col> */}

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={rfqData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateDocTypeV2Modal
        show={modalShow}
        onHide={() => hideModal()}
        // modaldata={modalData}
        dropdowndata={getPurchaseDocType}
        navigate={Constants.SOURCING_CREATE_RFQ}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
    </main>
  );
};

export default RequestForQuotationListV2;
